'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeScattermapboxIcon = function TraceTypeScattermapboxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', stroke: '#dfe8f3', d: 'M5.5 6H41v35.5H5.5zM5.5 11.2H41M5.5 16.4H41M5.5 21.1H41M5.5 26.3H41M5.5 31.4H41M5.5 36.6H41M10.7 41.4V6M15.8 41.5V6M20.5 41.5V6M25.7 41.5V6M30.9 41.5V6M36 41.5V6', strokeMiterlimit: '10', strokeWidth: '.25' }),
        _react2.default.createElement('path', { d: 'M0 0h46v46H0z', fill: 'none' }),
        _react2.default.createElement('path', { d: 'M31.5 28.3l-2.3 3.5-4.6 1.2-2.3-2.3h-3.5l-6.2 1.2-3.5-2.3L13 25v-3.5h5.2l4.2 3 4.5-3 9.2 6.9c0-.1-4.6-.1-4.6-.1z', fill: '#25fdfc', stroke: '#fff', strokeMiterlimit: '10' }),
        _react2.default.createElement('path', { d: 'M36.1 28.3l-9.2-6.9-4.5 3-4.2-3H13l-2.9-1.7v-2.3L9 16.2l-1.2 1.2-1.2-1.2v-4.6H9l2.3-1.2h2.3l3.5 2.3h3.5l4.6-2.3 3.5 3.5-3.5 3.5H31V15h3.5v1.2l1.2 1.2 1.2-1.2 3.5 3.5v3.5h-4v5.1zm-9.8 7.4l-1.2 1.2H24l.6-4-2.3-2.3h-3.5l-6.2 1.2 7.9 4V38l3.5 2.3h2.3l1.2-1.2v-2.3z', fill: '#25fdfc', stroke: '#fff', strokeMiterlimit: '10' }),
        _react2.default.createElement('circle', { cx: '36.9', cy: '20.4', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '22.4', cy: '20.4', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '10.9', cy: '14.4', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '15.9', cy: '24.4', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '13.9', cy: '28.4', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '25.9', cy: '27.4', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '13.9', cy: '17.4', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '20.9', cy: '26.4', r: '1', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '23.9', cy: '14.4', r: '1.5', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '30.9', cy: '20.4', r: '1', fill: '#1d9bfb' })
    );
};

exports.default = TraceTypeScattermapboxIcon;